import { render, staticRenderFns } from "./twoRight.vue?vue&type=template&id=d07d8b38&"
import script from "./twoRight.vue?vue&type=script&lang=js&"
export * from "./twoRight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports